import { Fragment, useState, useEffect } from "react";
import { notification, Button, Modal, Select } from "antd";
import { TitleHeader, Searcher, TableAntd } from "../../components";
import { ReloadOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import { Redirect } from "react-router-dom";
import { useAuth } from "../../utils/useAuth";
import { executeQuery, executeUpdate } from "../../api/sistema";
import { isPorSedeEnabled, getAllSedes } from "../../api/auxiliar";
import { createColumns } from "./formatTable";

function Participante() {
  const { isAdmin } = useAuth();

  const [filterTable, setFilterTable] = useState(null);
  const [page, setPage] = useState(1);

  const [dataToTable, setDataToTable] = useState([]);
  const [reload, setReload] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  
  const [porSedeEnabled, setPorSedeEnabled] = useState(false);
  const [sedes, setSedes] = useState([]);
  const [selectedSede, setSelectedSede] = useState(null);

  const fetchDataToTable = async () => {
    setIsLoading(true);

    executeQuery({
      query: "get_all_participantes",
      collection: "par_participante"
    })
      .then((res) => {
        setDataToTable(res.payload);
      })
      .catch((err) => {
        notification.error({
          message: "Problemas con la solicitud",
          description: err.message
        });
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const fetchPorSedeConfig = async () => {
    try {
      const res = await isPorSedeEnabled();
      setPorSedeEnabled(res.payload.porSedeEnabled);
      
      if (res.payload.porSedeEnabled) {
        const sedesRes = await getAllSedes();
        setSedes(sedesRes.payload);
      }
    } catch (err) {
      console.error("Error al obtener configuración de sede:", err);
    }
  };

  useEffect(() => {
    fetchDataToTable();
    fetchPorSedeConfig();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reload]);

  if (!isAdmin) return <Redirect to="/app" />;

  const onChangeState = (record) => {
    const activateMsg = record.activo ? "desactivar" : "activar";
    const actionMsg = record.activo ? "desactivado" : "activado";

    Modal.confirm({
      title: `¿Estás seguro de ${activateMsg} al postulante '${record.nombre}?'`,
      icon: <ExclamationCircleOutlined />,
      okText: "Sí, " + activateMsg,
      cancelText: "Cancelar",
      onOk() {
        executeUpdate(
          {
            collection: "pos_postulante",
            nombreid: "_id",
            valorid: record._id
          },
          {
            activo: !record.activo
          }
        )
          .then((res) => {
            if (res.success) {
              notification.success({
                message: "Operación exitosa",
                description: `Se ha ${actionMsg} al postulante satistactoriamente.`
              });
              fetchDataToTable();
            }
          })
          .catch(() => {
            notification.error({
              message: "Operación no válida",
              description: `No se pudo actualizar el estado, comuníquese con el administrador.`
            });
          });
      }
    });
  };

  const columnsToTable = createColumns(page, onChangeState, porSedeEnabled);

  const search = (value) => {
    const tempFilterTable = dataToTable.filter((o) =>
      Object.keys(o).some((k) => String(o[k]).toLowerCase().includes(value.toLowerCase()))
    );

    setFilterTable(tempFilterTable);
  };

  const handleSedeChange = (value) => {
    setSelectedSede(value);
  };

  const getFilteredData = () => {
    let data = filterTable == null ? dataToTable : filterTable;
    
    if (porSedeEnabled && selectedSede) {
      data = data.filter(item => item.idsede === selectedSede);
    }
    
    return data;
  };

  return (
    <Fragment>
      <TitleHeader
        title={
          <span className="flex gap-2 items-center">
            <h1 className="font-bold">Participantes ({getFilteredData().length})</h1>
            <Button
              size="small"
              icon={<ReloadOutlined />}
              onClick={() => setReload(!reload)}
            ></Button>
          </span>
        }
      />

      <div className="flex gap-2 mb-4 flex-col md:flex-row">
        <Searcher onSearch={search} placeholder="Busca algún participante" />
        
        {porSedeEnabled && (
          <Select
            placeholder="Filtrar por sede"
            allowClear
            style={{ width: 250 }}
            onChange={handleSedeChange}
            options={[
              { value: null, label: "Todas las sedes" },
              ...sedes.map(sede => ({
                value: sede.idsede,
                label: sede.nombre
              }))
            ]}
          />
        )}
      </div>

      <TableAntd
        columns={columnsToTable}
        dataSource={getFilteredData()}
        setPage={setPage}
        isLoading={isLoading}
      />
    </Fragment>
  );
}

export default Participante;
